<!-- <div class="bg-blue-500 text-white p-4">
  Ejemplo de clase de Tailwind CSS
</div> -->
<!-- <app-layouts></app-layouts> -->
<router-outlet></router-outlet>
